
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PeakShavingTimes } from '../Models/LoadsData';
import { ShaveTimesService } from './shave-times.service';

@Injectable({
  providedIn: 'root'
})
export class ShaveTimeResolverService implements Resolve<Array<PeakShavingTimes>> {
  ShaveTimesData: Observable<Array<PeakShavingTimes>>;
  constructor(private ShaveTimesSvc: ShaveTimesService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<PeakShavingTimes>> | Promise<Array<PeakShavingTimes>> | Array<PeakShavingTimes> {
    this.ShaveTimesData = this.ShaveTimesSvc.GetShaveTimes();
    return this.ShaveTimesData;
  }
}